module.exports = __webpack_public_path__ + "static/img/jpspot.10434e60.png";